
import Confirm from '@/components/confirm.vue'
import ClientForm from '@/components/client/form.vue'

export default {
  components: {
    'm-confirm': Confirm,
    'm-client-form': ClientForm
  },
  data () {
    return {
      dialog_client: false,
      dialog_client_edit: false,
      formClient: {},
      clientItem: {}
    }
  },
  methods: {
    closeClient () {
      this.dialog_client = false;
      this.dialog_client_edit = false;
      console.log('close');
    },
    resetClient () {
      this.dialog_client = false;
      this.dialog_client_edit = false;
      this.formClient = {};
    },
    saveClient (data, callback) {
      this.closeClient();
      // var app = this;
      this.$http
      .post('api/client', data)
      .then(response => {
        if (callback) {
          callback(response.data.insertId);
        }
        console.log('onSaveClient response data', response.data);
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  }
}
